import { z } from 'zod';
import { AppealStatusSchema } from '../appeals';
import { adminPage } from './page';

/* Admin review views for user appeals. */

export const AdminAppealSchema = z.object({
  id: z.string(),
  userId: z.string(),
  userHandle: z.string().nullable(),
  userEmail: z.string(),
  sanction: z.string(),
  body: z.string(),
  status: AppealStatusSchema,
  reviewedByHandle: z.string().nullable(),
  reviewedAt: z.iso.datetime().nullable(),
  decisionNote: z.string().nullable(),
  createdAt: z.iso.datetime(),
  /** current standing, so the reviewer has context */
  currentlyBanned: z.boolean(),
  currentlySuspendedUntil: z.iso.datetime().nullable(),
});
export type AdminAppeal = z.infer<typeof AdminAppealSchema>;

export const AdminAppealsResponseSchema = adminPage(AdminAppealSchema);
export type AdminAppealsResponse = z.infer<typeof AdminAppealsResponseSchema>;

/* POST /api/admin/appeals/:id/decision */
export const AppealDecisionSchema = z.object({
  decision: z.enum(['granted', 'denied']),
  note: z.string().min(3).max(500),
});
export type AppealDecision = z.infer<typeof AppealDecisionSchema>;
